import React from "react";

export const ServiceIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M15.578 2.43152L13.578 1.38197C11.8224 0.46066 10.9446 0 10.0003 0C9.05597 0 8.17817 0.46066 6.42256 1.38197L4.42256 2.43152C2.64882 3.36234 1.60617 3.9095 0.959961 4.64132L10.0003 9.1615L19.0406 4.64132C18.3944 3.9095 17.3518 3.36234 15.578 2.43152Z"
          fill="#E0E0E0"
        />
        <path
          d="M19.7484 5.96387L10.75 10.463V19.9035C11.4679 19.7247 12.2848 19.296 13.5777 18.6175L15.5777 17.568C17.7294 16.4388 18.8052 15.8743 19.4026 14.8598C20 13.8453 20 12.5828 20 10.058V9.94102C20 8.04842 20 6.8651 19.7484 5.96387Z"
          fill="#E0E0E0"
        />
        <path
          d="M9.25 19.9035V10.463L0.25164 5.96387C8.9407e-08 6.8651 0 8.04843 0 9.94103V10.058C0 12.5828 -5.96046e-08 13.8453 0.5974 14.8598C1.19479 15.8743 2.27063 16.4388 4.42229 17.568L6.42229 18.6175C7.71524 19.296 8.5321 19.7247 9.25 19.9035Z"
          fill="#E0E0E0"
        />
      </svg>
    </div>
  );
};
